/*
* Palo Alto Theme
*
* Use this file to add custom JavaScript to Palo Alto.  Keeping your custom
* JavaScript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


/* ENEA Studio — Quick-View "Item is unavailable" fix
 * ---------------------------------------------------
 * Theme: Palo Alto 6.2.0 (Maker Themes)
 *
 * Root cause: When a quick-view popup opens, the Palo Alto theme runs
 * ProductAddForm.init() on the popup form. That init unconditionally
 * applies the page's window.relatedVariants mutation, which prepends
 * a synthetic "Color" option to the product's options array. But the
 * quick-view form has no Color input, so the option array becomes
 * [undefined, value1, value2], no variant matches, and the ATC button
 * falls back to theme.strings.unavailable ("Item is unavailable").
 *
 * Fix: redefine window.relatedVariants and window.relatedVariantsColorLabel
 * as accessor properties that return undefined while a quick-view popup
 * is mounted in the DOM. Reads outside the popup are unaffected.
 *
 * This file is intended to be appended to assets/custom.js or pasted as
 * a <script> in layout/theme.liquid just before </body>. It is idempotent.
 */
(function () {
  if (window.__eneaQuickViewVariantFix) return;
  window.__eneaQuickViewVariantFix = true;

  // Capture whatever the inline Liquid script set up.
  var realRelated = window.relatedVariants;
  var realLabel = window.relatedVariantsColorLabel;

  function isQuickViewMounted() {
    // The quick-view container is in the DOM only while a popup is open.
    return !!document.querySelector(
      '[data-quick-view-inner], .popup-quick-view'
    );
  }

  try {
    Object.defineProperty(window, 'relatedVariants', {
      configurable: true,
      get: function () { return isQuickViewMounted() ? undefined : realRelated; },
      set: function (v) { realRelated = v; }
    });
    Object.defineProperty(window, 'relatedVariantsColorLabel', {
      configurable: true,
      get: function () { return isQuickViewMounted() ? undefined : realLabel; },
      set: function (v) { realLabel = v; }
    });
  } catch (e) {
    // If something already locked these properties, log and bail —
    // the original behavior remains untouched.
    if (window.console && console.warn) {
      console.warn('[ENEA quick-view fix] could not install accessor:', e);
    }
  }
})();


(function() {
  // Add custom code below this line

  // iJewel3D Floating Button
  
  document.addEventListener('click', (e) => {
    if (e.target.closest('.ijewel3d-floating-button')) {
      const floatingBtn = e.target.closest('.ijewel3d-floating-button');
      console.log('ijewel3dFloatingButton clicked');
      e.preventDefault();
      let parentContainer = floatingBtn.parentElement;
      if (floatingBtn.classList.contains('active')) {
        floatingBtn.classList.remove('active');
        if (parentContainer.querySelector('.ijewel3d-model-iframe')) {
          parentContainer.querySelector('.ijewel3d-model-iframe').classList.add('hidden');
        }
        return;
      } else {
        floatingBtn.classList.add('active');
        let iframe = parentContainer.querySelector('.ijewel3d-model-iframe');
        if (iframe) {
          iframe.classList.remove('hidden');
        } else {
          let modelSource = floatingBtn.getAttribute('data-3d-model');
          if (modelSource) {
            const iframe = document.createElement('iframe');
            iframe.src = modelSource;
            iframe.width = '100%';
            iframe.height = '100%';
            iframe.frameborder = '0';
            iframe.allow = 'autoplay; fullscreen; xr-spatial-tracking; web-share';
            iframe.allowfullscreen = true;
            iframe.mozallowfullscreen = true;
            iframe.webkitallowfullscreen = true;
            iframe.classList.add('ijewel3d-model-iframe');

            parentContainer.appendChild(iframe);
          }
        }
      }
    }
  });





  // ============================================================
  // KLAVIYO REVIEW DATES v3 (2026-05-30) — Targets exact selector
  // Targets ONLY div.kl_reviews__review__timestamp (plain-text divs).
  // Stars are in sibling div[role="img"][aria-label] — never touched.
  // No MutationObserver. Just 4 timed passes.
  // To revert: delete this entire (function(){...})(); block.
  // ============================================================
  (function() {
    function parseRelative(text) {
      var now = new Date();
      var d, m;
      var t = text.toLowerCase().trim();
      m = t.match(/(\d+)\s+years?\s+ago/);
      if (m) { d = new Date(now); d.setFullYear(d.getFullYear() - parseInt(m[1])); return d; }
      if (/\ba\s+year\s+ago\b/.test(t)) { d = new Date(now); d.setFullYear(d.getFullYear() - 1); return d; }
      m = t.match(/(\d+)\s+months?\s+ago/);
      if (m) { d = new Date(now); d.setMonth(d.getMonth() - parseInt(m[1])); return d; }
      if (/\ba\s+month\s+ago\b/.test(t)) { d = new Date(now); d.setMonth(d.getMonth() - 1); return d; }
      m = t.match(/(\d+)\s+weeks?\s+ago/);
      if (m) { d = new Date(now); d.setDate(d.getDate() - parseInt(m[1]) * 7); return d; }
      if (/\ba\s+week\s+ago\b/.test(t)) { d = new Date(now); d.setDate(d.getDate() - 7); return d; }
      m = t.match(/(\d+)\s+days?\s+ago/);
      if (m) { d = new Date(now); d.setDate(d.getDate() - parseInt(m[1])); return d; }
      if (/\ba\s+day\s+ago\b|\byesterday\b/.test(t)) { d = new Date(now); d.setDate(d.getDate() - 1); return d; }
      if (/hours?\s+ago|minutes?\s+ago|just\s+now/.test(t)) { return new Date(now); }
      return null;
    }
    function format(d) {
      if (!d || isNaN(d.getTime())) return null;
      var mm = String(d.getMonth() + 1).padStart(2, '0');
      var dd = String(d.getDate()).padStart(2, '0');
      return mm + '/' + dd + '/' + d.getFullYear();
    }
    function reformat() {
      var els = document.querySelectorAll('div.kl_reviews__review__timestamp');
      els.forEach(function(el) {
        var current = el.textContent.trim();
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(current)) return;
        var formatted = format(parseRelative(current));
        if (formatted) el.textContent = formatted;
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', reformat);
    } else {
      reformat();
    }
    setTimeout(reformat, 1500);
    setTimeout(reformat, 4000);
    setTimeout(reformat, 8000);
  })();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

/* ENEA Studio — Mobile color-swatch thumbnail fix
 * --------------------------------------------------
 * On product cards (collection grid + upsell rows) the custom color
 * swatches (.swatch__link-custom) call the theme's existing inline
 * handler in theme.js, which swaps the <img> inside
 * `.product__media__image`. On mobile (≤767px), the visible image is
 * actually the first <img> inside `.product-image-slider .slider-track`
 * (the swipeable mobile gallery), so the swap never appears.
 *
 * This patch listens for the same click in capture phase, finds BOTH
 * the desktop featured image and the mobile slider's first image, and
 * updates them in sync. It is safe and additive — runs before the
 * theme's own handler and does not preventDefault, so the existing
 * desktop swap continues to work exactly as before.
 *
 * Idempotent: guarded by window.__eneaMobileSwatchFix.
 */
(function () {
  if (window.__eneaMobileSwatchFix) return;
  window.__eneaMobileSwatchFix = true;

  function syncCardImages(swatchLink) {
    var card = swatchLink.closest('.product-grid-item');
    if (!card) return;
    var newSrc = swatchLink.getAttribute('data-swatch-image');
    if (!newSrc) return;

    // 1) Desktop featured image (theme already does this, but doing it
    //    here too is harmless and ensures sync if the theme handler
    //    ever changes).
    var featured = card.querySelector('.product__media__image img');
    if (featured && featured.getAttribute('src') !== newSrc) {
      featured.setAttribute('src', newSrc);
      featured.removeAttribute('srcset');
    }

    // 2) Mobile swipeable slider — first <img> inside .slider-track.
    var sliderImg = card.querySelector('.product-image-slider .slider-track img');
    if (sliderImg) {
      sliderImg.setAttribute('src', newSrc);
      sliderImg.removeAttribute('srcset');
    }

    // 3) Hover image (the secondary fade-in image shown on desktop hover).
    //    Update it too so the hover preview matches the selected color.
    var hoverImg = card.querySelector('.product__media__hover-img img, [data-product-image-hover] img');
    if (hoverImg && newSrc) {
      // Only update if the hover image is the generic site-wide one; we
      // don't want to break existing per-product hover photos. Heuristic:
      // skip if hover src already differs from the featured src.
      // (Disabled by default — uncomment if you want hover to follow.)
      // hoverImg.setAttribute('src', newSrc);
      // hoverImg.removeAttribute('srcset');
    }
  }

  // Capture phase so we run before the theme's bubbling handler.
  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest && e.target.closest(
      '.product-grid-item__swatch-custom .swatch__link-custom'
    );
    if (!link) return;
    // Mirror the theme handler's behaviour so navigation doesn't
    // happen on touch devices either.
    e.preventDefault();
    syncCardImages(link);
  }, true);

  // Also handle touchend for older iOS Safari versions where the
  // synthesised click may be suppressed by 300ms-tap logic.
  document.addEventListener('touchend', function (e) {
    var link = e.target && e.target.closest && e.target.closest(
      '.product-grid-item__swatch-custom .swatch__link-custom'
    );
    if (!link) return;
    syncCardImages(link);
  }, { passive: true, capture: true });
})();

/* ============================================================
   ENEA — COLLECTION CARD IMAGE SWIPE (unified, v0.3.0 2026-06-05)
   Replaces the three older, overlapping patches that used to live
   here (tap-jitter fix v3, lazy re-bind v4, strict-tap v2). ONE
   controller now owns the product-card thumbnail swipe on
   collection / grid pages:
     - horizontal swipe between a card's images (touch + mouse)
     - STRONG direction lock: once a gesture reads as horizontal,
       vertical page scroll is blocked (preventDefault) for the rest
       of that gesture, and borderline / diagonal gestures are
       treated as horizontal via VERTICAL_BIAS, so dragging the
       thumbnails no longer drifts the page up and down.
       --> raise VERTICAL_BIAS for even more vertical resistance.
     - a real swipe suppresses the click so it does not open the PDP;
       a plain tap still navigates to the product.
   It binds in the CAPTURE phase and stops propagation, so the
   theme's own swipeProductImages() (bubble phase) never double-
   handles the gesture. This is consistent for both the initial
   cards and cards added later by infinite scroll / filters, driven
   by ONE debounced MutationObserver (the old code used three).
   Idempotent: guarded by window.__eneaCollectionSwipeV3.
   To revert: delete this entire (function () { ... })(); block.
   ============================================================ */
(function () {
  if (window.__eneaCollectionSwipeV3) return;
  window.__eneaCollectionSwipeV3 = true;

  var DEAD_ZONE     = 6;    // px of movement before a direction is locked
  var VERTICAL_BIAS = 1.6;  // only lock 'vertical' when |dy| > |dx| * BIAS
                            //   higher = harder to scroll the page while
                            //   swiping thumbnails (more vertical resistance)
  var SETTLE_PX     = 45;   // horizontal px past which we advance an image

  function bind(track) {
    if (!track || track.__eneaSwipeBound) return;
    track.__eneaSwipeBound = true;

    var total = track.querySelectorAll('img').length;
    if (total < 2) return; // single-image cards have nothing to swipe

    var card  = track.closest('.product-grid-item');
    var index = 0;
    var startX = 0, startY = 0, lock = null, dragging = false, moved = false;

    function settleTo(i) {
      index = Math.max(0, Math.min(total - 1, i));
      track.style.transition = 'transform 0.45s ease';
      track.style.transform  = 'translateX(-' + (index * (100 / total)) + '%)';
    }
    function dragTo(diffPx) {
      var base = -index * (100 / total);
      track.style.transition = 'none';
      track.style.transform  = 'translateX(calc(' + base + '% + ' + diffPx + 'px))';
    }
    function suppressClick() {
      if (!card) return;
      var h = function (ev) {
        ev.stopPropagation();
        ev.preventDefault();
        card.removeEventListener('click', h, true);
      };
      card.addEventListener('click', h, true);
      setTimeout(function () { card.removeEventListener('click', h, true); }, 400);
    }

    /* ---- touch (mobile / tablet) ---- */
    track.addEventListener('touchstart', function (e) {
      if (!e.touches || !e.touches[0]) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      lock = null; moved = false;
    }, { capture: true, passive: true });

    track.addEventListener('touchmove', function (e) {
      if (!e.touches || !e.touches[0]) return;
      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;
      var ax = Math.abs(dx), ay = Math.abs(dy);

      if (lock === null) {
        if (ax < DEAD_ZONE && ay < DEAD_ZONE) { e.stopPropagation(); return; } // swallow jitter
        lock = (ay > ax * VERTICAL_BIAS) ? 'v' : 'h';                          // bias to horizontal
      }

      e.stopPropagation(); // theme's own handler never runs

      if (lock === 'h') {
        if (e.cancelable) e.preventDefault(); // block vertical page scroll
        moved = true;
        dragTo(dx);
      }
      // lock === 'v': no preventDefault -> native vertical scroll continues
    }, { capture: true, passive: false });

    track.addEventListener('touchend', function (e) {
      if (lock === 'h') {
        e.stopPropagation();
        var dx = (e.changedTouches && e.changedTouches[0])
          ? e.changedTouches[0].clientX - startX : 0;
        if (dx <= -SETTLE_PX) settleTo(index + 1);
        else if (dx >= SETTLE_PX) settleTo(index - 1);
        else settleTo(index);
        if (moved) suppressClick();
      }
      lock = null;
    }, { capture: true, passive: true });

    track.addEventListener('touchcancel', function () {
      if (lock === 'h') settleTo(index);
      lock = null;
    }, { capture: true, passive: true });

    /* ---- mouse drag (desktop) — listeners bound on demand, removed on
       release, so nothing accumulates on document ---- */
    function onMouseMove(e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > DEAD_ZONE) moved = true;
      dragTo(dx);
    }
    function onMouseUp(e) {
      document.removeEventListener('mousemove', onMouseMove, true);
      document.removeEventListener('mouseup', onMouseUp, true);
      if (!dragging) return;
      dragging = false;
      var dx = e.clientX - startX;
      if (dx <= -SETTLE_PX) settleTo(index + 1);
      else if (dx >= SETTLE_PX) settleTo(index - 1);
      else settleTo(index);
      if (moved) suppressClick();
    }
    track.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      startX = e.clientX; startY = e.clientY; dragging = true; moved = false;
      e.preventDefault(); // stop native image drag-ghost
      document.addEventListener('mousemove', onMouseMove, true);
      document.addEventListener('mouseup', onMouseUp, true);
    }, { capture: true });

    /* ---- prev / next arrows (capture + stopPropagation so the theme's
       own arrow handler can't also advance the slider) ---- */
    var nextBtn = card && card.querySelector('.next-btn');
    var prevBtn = card && card.querySelector('.prev-btn');
    if (nextBtn) nextBtn.addEventListener('click', function (e) {
      e.stopPropagation(); e.preventDefault();
      settleTo(index + 1 > total - 1 ? 0 : index + 1);
    }, true);
    if (prevBtn) prevBtn.addEventListener('click', function (e) {
      e.stopPropagation(); e.preventDefault();
      settleTo(index - 1 < 0 ? total - 1 : index - 1);
    }, true);

    settleTo(0);
  }

  function bindAll() {
    document.querySelectorAll('.product-grid-item .slider-track').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }

  // ONE debounced observer for infinite scroll / filters / AJAX re-renders.
  var debounce;
  var mo = new MutationObserver(function () {
    clearTimeout(debounce);
    debounce = setTimeout(bindAll, 150);
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();

/* ============================================================
   ENEA v0.2.0 — PDP MOBILE GALLERY HORIZONTAL SWIPE LOCK
   Problem: on mobile PDP, swiping the product images left/right
   easily scrolls the page up/down because the slider has no
   direction lock. Small vertical drift during a horizontal swipe
   bounces the whole page.
   Fix: on the first 8px of movement, decide if the gesture is
   horizontal or vertical. If horizontal, preventDefault to stop
   page scroll for the rest of this gesture. If vertical, do not
   interfere with native scroll.
   Scope: PDP gallery only (.product-gallery__media-slider).
   Mobile only (matchMedia <= 749px).
   Idempotent: guarded by window.__eneaPDPSwipeLockV1.
   To revert: delete this entire (function () { ... })(); block.
   ============================================================ */
(function () {
  if (window.__eneaPDPSwipeLockV1) return;
  window.__eneaPDPSwipeLockV1 = true;

  var DIRECTION_THRESHOLD = 8;  // px before we lock direction
  var mqMobile = window.matchMedia('(max-width: 749px)');

  function attach(slider) {
    if (!slider || slider.__eneaPDPLockBound) return;
    slider.__eneaPDPLockBound = true;

    var sx = 0, sy = 0;
    var locked = null; // 'h' | 'v' | null

    slider.addEventListener('touchstart', function (e) {
      if (!mqMobile.matches) return;
      if (!e.touches || !e.touches[0]) return;
      sx = e.touches[0].clientX;
      sy = e.touches[0].clientY;
      locked = null;
    }, { passive: true, capture: true });

    slider.addEventListener('touchmove', function (e) {
      if (!mqMobile.matches) return;
      if (!e.touches || !e.touches[0]) return;
      var dx = e.touches[0].clientX - sx;
      var dy = e.touches[0].clientY - sy;

      if (locked === null) {
        if (Math.abs(dx) < DIRECTION_THRESHOLD && Math.abs(dy) < DIRECTION_THRESHOLD) {
          return; // still inside dead zone
        }
        locked = Math.abs(dx) > Math.abs(dy) ? 'h' : 'v';
      }

      if (locked === 'h') {
        // Horizontal swipe wins -> stop the page from scrolling vertically
        // for the rest of this gesture. Must be cancelable (not passive).
        if (e.cancelable) e.preventDefault();
      }
      // If locked === 'v', do nothing — native vertical scroll continues.
    }, { passive: false, capture: true });

    slider.addEventListener('touchend', function () {
      locked = null;
    }, { passive: true, capture: true });

    slider.addEventListener('touchcancel', function () {
      locked = null;
    }, { passive: true, capture: true });
  }

  function scan() {
    document.querySelectorAll(
      '.shopify-section--product .product-gallery__media-slider'
    ).forEach(attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // Re-scan on AJAX / variant changes that may re-render the gallery.
  var mo = new MutationObserver(scan);
  mo.observe(document.body, { childList: true, subtree: true });
})();


/* ============================================================
   ENEA - CART DRAWER EMPTY-STATE + REFRESH FIX (2026-06-05 v2)
   The theme's custom refreshDrawer() only swapped the items list,
   count and total on an AJAX remove. It never switched the drawer to
   its empty state, so removing every item left ADD ORDER NOTES / IS
   THIS A GIFT / CHECKOUT FREE on screen instead of "Your bag is empty".

   v1 tried to copy that visibility from /cart?view=drawer, but that
   response does not contain the empty-message / notes / checkout
   chrome, so the copy was a no-op. v2 decides the empty state itself
   from whether any line items remain, and applies it on ANY drawer
   change (the Remove link OR the quantity stepper). It also keeps a
   race-safe item re-render for the custom remove path.
   Idempotent: guarded by window.__eneaCartRefreshFix.
   ============================================================ */
(function () {
  if (window.__eneaCartRefreshFix) return;
  window.__eneaCartRefreshFix = true;

  var token = 0;

  function setHidden(sel, on) {
    document.querySelectorAll(sel).forEach(function (el) {
      el.classList.toggle('hidden', on);
    });
  }

  // Single source of truth: is the drawer empty? (any line items left?)
  function applyCartEmptyState() {
    var holder = document.querySelector('#cartItemsHolder');
    if (!holder) return;
    var empty = holder.children.length === 0;
    setHidden('#cartItemsHolder', empty);
    setHidden('[data-cart-notes-holder]', empty);
    setHidden('#cartDrawerCheckoutForm', empty);
    setHidden('[data-pair-products-holder], #cartUpsellHolder', empty);
    setHidden('#cartDrawerEmptyMessage', !empty); // show empty message ONLY when empty
  }
  window.eneaApplyCartEmptyState = applyCartEmptyState;

  // Race-safe item re-render for the custom Remove-link path.
  function syncHTML(doc, sel) {
    var n = doc.querySelector(sel), o = document.querySelector(sel);
    if (n && o) o.innerHTML = n.innerHTML;
  }
  window.refreshDrawer = async function () {
    var mine = ++token;
    try {
      var res = await fetch('/cart?view=drawer', { cache: 'no-store' });
      if (!res.ok) { applyCartEmptyState(); return; }
      var html = await res.text();
      if (mine !== token) return; // a newer refresh started - let it win
      var doc = new DOMParser().parseFromString(html, 'text/html');
      syncHTML(doc, '#cartItemsHolder');
      syncHTML(doc, '[data-cart-items-qty]');
      syncHTML(doc, '[data-cart-total-price]');
      applyCartEmptyState();
      if (typeof checkAndShowUpsell === 'function') {
        try { await checkAndShowUpsell(); } catch (e) {}
      }
    } catch (e) {
      applyCartEmptyState();
      if (window.console && console.warn) console.warn('[ENEA cart refresh]', e);
    }
  };

  // Catch-all: re-apply the empty state whenever the drawer contents change,
  // no matter which remove path fired. One debounced observer on the stable
  // wrapper. (childList only, so toggling classes can't loop it.)
  function watch() {
    var drawer = document.querySelector('#cart-drawer');
    if (!drawer) return false;
    if (drawer.__eneaEmptyWatch) return true;
    drawer.__eneaEmptyWatch = true;
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(applyCartEmptyState, 60);
    }).observe(drawer, { childList: true, subtree: true });
    applyCartEmptyState();
    return true;
  }
  if (!watch()) {
    var tries = 0;
    var iv = setInterval(function () { if (watch() || ++tries > 40) clearInterval(iv); }, 500);
  }
})();